<div>
  <div class="c-filter tw-flex tw-w-full tw-flex-wrap tw-items-center lg:tw-flex-nowrap">
    <!-- Search input -->
    <div class="c-filter__section tw-w-full tw-pb-3 lg:tw-w-auto lg:tw-flex-auto lg:tw-pb-0">
      <div class="tw-relative">
        <input
          class="form-control tw-pl-12"
          placeholder="{{ 'campaign.searchPlaceholder' | translate }}"
          [(ngModel)]="params.filterString"
          (keydown.enter)="submit(params, false)"
          name="search"
          required
        />
        <div class="pitchin-icon pitchin-icon-search tw-absolute tw-left-3 tw-top-3"></div>
      </div>
    </div>

    <div class="c-filter__section tw-flex tw-items-center lg:tw-pl-3">
      <!-- Toggle filter starts -->
      <div class="toggle-filter">
        <app-campaign-filters-toggle
          [filterMenus]="filtersMenus"
          [filterTags]="filterTags"
          [selectedMenu]="selectedFilterMenu"
          [selectedMenuIndex]="selectedFilterMenuIndex"
          [portalName]="'#c-filter__dropdown-section'"
          (onSelectedMenuChange)="handleSelectedMenuChange($event)"
          (onFiltersChange)="handleFiltersChange($event)"
        />
      </div>
      <div class="c-filter__divider"></div>
      <!-- Sorting -->
      <div class="dropdown" ngbDropdown>
        <div
          class="d-flex align-items-center cursor-pointer tw-select-none"
          id="filterButton"
          aria-controls="menu"
          ngbDropdownToggle
        >
          <span class="pr-1 tw-font-semibold">{{ 'common.sortBy' | translate }}:</span>
          {{ 'campaign.' + InvestmentFilterType[params.orderBy] | translate }}
          <i class="fa fa-caret-down tw-ml-2 tw-opacity-50"></i>
        </div>
        <div class="dropdown-menu" ngbDropdownMenu role="menu" aria-labelledby="filterButton">
          @for (type of InvestmentFilterType | enumToArray; track type) {
            <div
              role="menuitem"
              class="dropdown-item font-weight-bold font-size-regular cursor-pointer"
              (click)="selectFilterType(type.key)"
              data-t="sortClick"
            >
              {{ 'campaign.' + type.value | translate }}
            </div>
          }
        </div>
      </div>
    </div>
  </div>

  <!-- Where should be teleported to -->
  <div id="c-filter__dropdown-section" class="c-filter__dropdown-section"></div>

  <!-- Sectors -->
  <!-- <div class="toggle-filter__section">
      <div class="filter-label">{{ "campaign.sectors" | translate }}</div>
      <div class="filter-selections">
        <app-select-search-filter
          class="w-100"
          [(list)]="sectors"
          [(selectedList)]="params.selectedSectors"
          [placeholder]="'company.searchSectors'"
          (goSearch)="getSectors($event)"
          >
        </app-select-search-filter>
      </div>
    </div> -->
</div>

<!-- Tags -->
@if (filterTags.length > 0) {
  <div class="tw-mt-1">
    <ul class="filter-tag">
      @for (tag of filterTags; track tag) {
        <li class="filter-tag__item" (click)="handleRemoveTag(tag)">
          {{ tag.label }}
          <i class="fa fa-times"></i>
        </li>
      }
    </ul>
  </div>
}
